import { Header, rankifierLogo } from "@datagame/ui";
import { t } from "i18next";

import { useRankifierState } from "../../../hooks/useRankifierState";
import { useGlobalConfiguration } from "../../../hooks/useGlobalConfiugration";

import styles from "./Heading.module.scss";

export const Heading = () => {
  const { hideDatagameBranding } = useGlobalConfiguration();
  const [state] = useRankifierState();

  const {
    status: { round },
    game: {
      configuration: { numberOfHands },
    },
  } = state;

  const currentRound = round > numberOfHands ? numberOfHands : round;

  return (
    <div className={styles.rankifierTopBar}>
      <div className={styles.logoWrapper}>
        {!hideDatagameBranding && (
          <>
            <img className={styles.logoImage} src={rankifierLogo} alt="rankifier logo" />
            <Header className={styles.logoText} variant="h6">
              {t("rankifier.headline")}
            </Header>
          </>
        )}
      </div>
      <Header className={styles.roundTracker} variant="h6">
        <span className={styles.currentRound}>{currentRound}</span>/{numberOfHands}
      </Header>
    </div>
  );
};
